import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { listItemShape } from '@bibliocommons/bc-prop-types';

import { generateKeyForListItem } from 'app/helpers/list/listEditorHelpers';
import InlineTextArea from 'app/components/shared/InlineTextArea';
import '../styles/ItemAnnotationInput.scss';

export class ItemAnnotationInput extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  renderLabelContents() {
    if (this.props.renderLabelContents) {
      return this.props.renderLabelContents;
    }

    return <FormattedMessage id="ada_label_edit_list_item_annotation_no_title" />;
  }

  render() {
    if (!this.props.allowFreeText) {
      return null;
    }

    const key = this.props.item ? generateKeyForListItem(this.props.item) : 'new';
    const labelId = `${key}-item-annotation-label`;
    const inputId = `${key}-item-annotation-input`;

    return (
      <div className="cp-item-annotation-input">
        <ScreenReaderMessage>
          <label id={labelId} htmlFor={inputId}>
            {this.renderLabelContents()}
          </label>
        </ScreenReaderMessage>

        <InlineTextArea
          id={inputId}
          labelledById={labelId}
          value={this.props.value}
          maxLength={4000}
          highlightOnHover
          handleChange={this.props.handleChange}
          prompt={this.props.intl.formatMessage({
            id: 'user_list_add_annotation'
          })}
          buttonTestId="edit-item-annotation-button"
          inputTestId="item-annotation-text-area"
          fitToText
        >
          <span className="user-annotation" data-test-id="item-annotation-value">
            {this.props.value}
          </span>
        </InlineTextArea>
      </div>
    );
  }
}

ItemAnnotationInput.propTypes = {
  value: PropTypes.string,
  renderLabelContents: PropTypes.element,
  allowFreeText: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  item: listItemShape
};

export default injectIntl(ItemAnnotationInput);
